module.exports = __webpack_public_path__ + "img/ni-favicon-white.0de327df.svg";